// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"4e0ea6c8","295":"4e0ea6c8","639":"4e0ea6c8","705":"55b67a01","819":"4e0ea6c8","858":"4e0ea6c8","905":"b0717cb4"}[chunkId] + ".chunk.css";
};